import {
    createColumnDate,
    createColumnInput,
    createColumnInputNumber,
    createColumnSelect
} from "../../../../components/table/c-table.logic";
import i18n from "../../../../i18n";
import { callBank, callBankType, callFeeStatus, callFeeType, callRequestDoc } from "./fee.logic";
import lodash from "lodash";
import { conditionFormChecker, putField } from "../../../../utils/form";
import {
    createFieldAttachment,
    createFieldDate,
    createFieldDatetime,
    createFieldInput,
    createFieldRadioGroup,
    createFieldSelect,
    createFieldTextArea
} from "../../../../components/input/template-builder/template-builder.logic";
import moment from "moment";
import { defineAsyncComponent } from "vue";
import store from "../../../../store";
import { dateFormat } from "../../../../utils/date";

const FeeStatementInlineList = defineAsyncComponent(() => import("./FeeStatementInlineList"));

export const createColumns = ({ props }) => {
    const { columnTemplate } = props;
    const columns = [
        createColumnInput({ title: () => i18n.global.t("model.feeStatement.companyName"), dataIndex: "companyName", align: "center" }),
        createColumnInput({ title: () => i18n.global.t("model.feeStatement.feeCode"), dataIndex: "feeCode", align: "center" }),
        createColumnInput({ title: () => i18n.global.t("model.feeStatement.receiptCode"), dataIndex: "receiptCode", align: "center" }),
        createColumnDate({ title: () => i18n.global.t("model.feeStatement.feeDate"), dataIndex: "feeDate", align: "center" }),
        createColumnDate({ title: () => i18n.global.t("model.feeStatement.dueDate"), dataIndex: "dueDate", align: "center" }),
        createColumnInput({
            title: () => i18n.global.t("model.feeStatement.refRequest"),
            dataIndex: "refRequest.requestCode",
            align: "center",
            customRender: ({ record }) => {
                return <div>{record.refRequest?.requestCode}</div>;
            }
        }),
        createColumnInput({ title: () => i18n.global.t("model.feeStatement.requestNumber1"), dataIndex: "requestNumber1", align: "center" }),
        createColumnInput({ title: () => i18n.global.t("model.feeStatement.requestNumber2"), dataIndex: "requestNumber2", align: "center" }),
        createColumnInputNumber({ title: () => i18n.global.t("model.feeStatement.netAmount"), dataIndex: "netAmount", align: "center" }),
        createColumnSelect({
            title: () => i18n.global.t("model.feeStatement.refType"),
            dataIndex: "refType.value",
            customRender: ({ record }) => <div>{record.refType?.value}</div>,
            inputProp: () => ({ list: callFeeType, optLabel: "value" }),
            align: "center",
            search: {
                name: "refType.id"
            }
        }),
        createColumnSelect({
            title: () => i18n.global.t("model.feeStatement.refStatus"),
            dataIndex: "refStatus.value",
            customRender: ({ record }) => <div>{record.refStatus?.value}</div>,
            inputProp: () => ({ list: callFeeStatus, optLabel: "value" }),
            align: "center",
            search: {
                name: "refStatus.id"
            }
        }),
        createColumnSelect({
            title: () => i18n.global.t("model.request.refRequestDoc"),
            dataIndex: "refRequest.refRequestDoc.value",
            customRender: ({ record }) => <div>{record.refRequest?.refRequestDoc?.value}</div>,
            inputProp: () => ({ list: callRequestDoc, optLabel: "value" }),
            align: "center",
            search: {
                name: "refRequest.refRequestDoc.id"
            }
        }),
        createColumnInput({
            title: () => i18n.global.t("model.feeStatement.refOfficer"),
            dataIndex: "refOfficer.fullNameTh",
            customRender: ({ record }) => {
                return <div>{record.refOfficer?.fullNameTh}</div>;
            }
        }),
    ];

    const template1 = [
        "feeCode",
        "feeDate",
        "dueDate",
        "companyName",
        "requestNumber1",
        "requestNumber2",
        "netAmount",
        "refStatus.value",
    ];
    const template2 = [
        "companyName",
        "receiptCode",
        "feeCode",
        "requestNumber1",
        "requestNumber2",
        "refRequest.refRequestDoc.value",
        "netAmount",
        "refType.value",
        "refStatus.value",
    ];
    if (columnTemplate === "template1") {
        return lodash.sortBy(columns.filter(d => template1.includes(d.dataIndex)), [d => template1.indexOf(d.dataIndex)]);
    }
    if (columnTemplate === "template2") {
        return lodash.sortBy(columns.filter(d => template2.includes(d.dataIndex)), [d => template2.indexOf(d.dataIndex)]);
    }
    return columns;
};

export const createFieldFeeInfo = ({ props, data, key }) => {
    const { viewOnly } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    const prefix = key ? `${key}.` : "";
    return putField({
        data,
        fields: [
            {
                visible: () => model.refStatus?.key === 'waitPayment',
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 4 }, wrapperCol: { xs: 24, md: 20 } }),
                inputRender: () => (
                    <div className="text-primary ml-4 pl-3 mb-3" style={"line-height: 1.5;"}>
                        <div>คำแนะนำสำหรับการชำระเงิน</div>
                        <div>1. กดปุ่ม (Download) ใบแจ้งการชำระค่าธรรมเนียม เพื่อชำระเงินโดยการแสกน QR Code ผ่าน Mobile Banking</div>
                        <div class="ml-3">   หรือชำระที่ตู้ ATM/INTERNET BANKING/ธนาคารสาขา</div>
                        <div>2. การชำระเงินด้วยวิธีอื่น ให้ปฏิบัติตามคู่มือของกรมประมง หรือติดต่อเจ้าหน้าที่</div>
                    </div>)
            },
            createFieldInput({
                visible: ({ field }) => viewOnly && conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refType`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 4 }, wrapperCol: { xs: 24, md: 8 } }),
                label: () => i18n.global.t("model.feeStatement.refType"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refType?.value,
                            disabled: true,
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) }
            }),
            createFieldRadioGroup({
                visible: ({ field }) => !viewOnly && conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refType`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 4 }, wrapperCol: { xs: 24, md: 20 } }),
                label: () => i18n.global.t("model.feeStatement.refType"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refType,
                            "onUpdate:value": value => {
                                model.refType = value;
                                if (["1", "2"].includes(value?.key)) {
                                    const userBank = modelRef.lastUserBank?.active?.[0]
                                    modelRef.refUserBank = userBank;
                                    modelRef.refBank = userBank?.refBank;
                                    modelRef.branch = userBank?.branch;
                                    modelRef.refBankType = userBank?.refType;
                                    modelRef.branchCode = userBank?.branchCode;
                                    modelRef.bankName = userBank?.bankName;
                                    modelRef.bankAccount = userBank?.bankAccount;
                                    modelRef.customerName = null;
                                } else {
                                    modelRef.refUserBank = null;
                                    modelRef.refBank = null;
                                    modelRef.branch = null;
                                    modelRef.refBankType = null;
                                    modelRef.branchCode = null;
                                    modelRef.bankName = null;
                                    modelRef.bankAccount = null;
                                    modelRef.customerName = null;
                                }
                                if (value?.key === "3") {
                                    modelRef.attachments.forEach(d=>{
                                        if (d.isDeleteOld != null) { d.isDelete = d.isDeleteOld; }
                                    });
                                } else {
                                    modelRef.attachments.forEach(d=>{
                                        d.isDeleteOld = !!d.isDelete;
                                        d.isDelete = true;
                                    });
                                }
                                if (value?.key === "4") {
                                    modelRef.refOfficer = lodash.cloneDeep(store.state.resource.auth.info?.user);
                                } else {
                                    modelRef.refOfficer = null;
                                }
                                if(!modelRef.payDatetime) {
                                    modelRef.payDatetime = moment().format("YYYY-MM-DD[T]HH:mm:ssZ");
                                }
                                if (!modelRef.customerName) {
                                    modelRef.customerName = lodash.cloneDeep(store.state.resource.auth.info?.user?.fullNameTh);
                                }
                            },
                            disabled: viewOnly,
                            // list -> code in fee.condition.js
                            optLabel: "value"
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) }
            }),
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refBank`,
                colProp: () => ({ xs: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.feeStatement.refBank"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refBank,
                            "onUpdate:value": value => (model.refBank = value),
                            disabled: true,
                            list: callBank,
                            optLabel: "value"
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) }
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}branch`,
                colProp: () => ({ xs: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.feeStatement.branch"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.branch,
                            disabled: true,
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) }
            }),
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refBankType`,
                colProp: () => ({ xs: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.feeStatement.refBankType"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refBankType,
                            "onUpdate:value": value => (model.refBankType = value),
                            disabled: true,
                            list: callBankType,
                            optLabel: "value"
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) }
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}branchCode`,
                colProp: () => ({ xs: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.feeStatement.branchCode"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.branchCode,
                            disabled: true,
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) }
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}bankName`,
                colProp: () => ({ xs: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.feeStatement.bankName"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.bankName,
                            disabled: true,
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) }
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}bankAccount`,
                colProp: () => ({ xs: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.feeStatement.bankAccount"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.bankAccount,
                            disabled: true,
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) }
            }),
            createFieldAttachment({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                key: `${prefix}attachments`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 4 }, wrapperCol: { xs: 24, md: 20 } }),
                label: () => i18n.global.t("model.attachment.modelName"),
                inputProp: ({ field }) => {
                    return lodash.merge(
                        {
                            value: model.attachments,
                            listType: "picture-card",
                            showUploadList: { showPreviewIcon: true, showRemoveIcon: false },
                            multiple: true,
                            disabled: viewOnly
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field, model } })
                    );
                }
            }),
            createFieldDatetime({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}payDatetime`,
                colProp: () => ({ xs: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.feeStatement.payDatetime"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.payDatetime,
                            "onUpdate:value": value => (model.payDatetime = value),
                            disabled: viewOnly,
                            valueFormat: ["1"].includes(model.refType?.key) ? "YYYY-MM-DD[T]HH:mm:ss.SSZ" : "YYYY-MM-DD[T]HH:mm:ssZ",
                            format: ["1", "2", "5"].includes(model.refType?.key) ? "DD/MM/YYYY HH:mm:ss" : "DD/MM/YYYY HH:mm",
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}customerName`,
                colProp: () => ({ xs: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.feeStatement.customerName"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.customerName,
                            "onUpdate:value": value => (model.customerName = value),
                            disabled: viewOnly
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refKtb.resTranxId`,
                colProp: () => ({ xs: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.feeStatement.info.resTranxId"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refKtb?.resTranxId,
                            disabled: true
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refKtb.resBankRef`,
                colProp: () => ({ xs: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.feeStatement.info.resBankRef"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refKtb?.resBankRef,
                            disabled: true
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refKtb.reqComCode`,
                colProp: () => ({ xs: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.feeStatement.info.reqComCode"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refKtb?.reqComCode,
                            disabled: true
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refKtb.reqEffDate`,
                colProp: () => ({ xs: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.feeStatement.info.reqEffDate"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refKtb?.reqEffDate ? moment(model.refKtb?.reqEffDate, 'YYYYMMDD',true).format("YYYY-MM-DD") : model.refKtb?.reqEffDate,
                            disabled: true
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refKtb.resRespCode`,
                colProp: () => ({ xs: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.feeStatement.info.resRespCode"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: `${model.refKtb?.resRespCode} - ${model.refKtb?.resRespMsg}`,
                            disabled: true
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            {
                visible: () => true,
                colProp: () => ({ xs: 24 }),
                formItemRender: () => <div></div>,
            },
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refKtbPaynet.payService`,
                colProp: () => ({ xs: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.feeStatement.info.payService"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refKtbPaynet?.payService,
                            disabled: true
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refKtbPaynet.payRef`,
                colProp: () => ({ xs: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.feeStatement.info.payRef"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refKtbPaynet?.payRef,
                            disabled: true
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refKtbPaynet.ktbRef`,
                colProp: () => ({ xs: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.feeStatement.info.ktbRef"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refKtbPaynet?.ktbRef,
                            disabled: true
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refKtbPaynet.vendorId`,
                colProp: () => ({ xs: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.feeStatement.info.vendorId"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refKtbPaynet?.vendorId,
                            disabled: true
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldTextArea({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refKtbPaynet.rspCode`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 4 }, wrapperCol: { xs: 24, md: 20 } }),
                label: () => i18n.global.t("model.feeStatement.info.rspCode"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: `${model.refKtbPaynet?.rspCode || ''} - ${model.refKtbPaynet?.rspMsg || ''}` ,
                            disabled: true,
                            row: 1
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            {
                visible: () => true,
                colProp: () => ({ xs: 24 }),
                formItemRender: () => <div></div>,
            },
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refOfficer.fullNameTh`,
                colProp: () => ({ xs: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.feeStatement.refOfficer"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refOfficer?.fullNameTh,
                            disabled: true,
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) }
            }),

            createFieldTextArea({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}nswServiceLogs`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 5 }, wrapperCol: { xs: 24, md: 19 } }),
                label: () => i18n.global.t("model.feeStatement.info.nswServiceLogs"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.serviceLogs?.filter(d => d.result && ["PAIN008", "PAIN002", "PAIN002_ERR", "CAMT054", "CAMT054_ERR"].includes(d.messageType)).map(d =>
                                `[${dateFormat({ text: d.createDate, format: "DD/MM/YYYY HH:mm:ss" })}] ${d.messageType}: ${JSON.stringify(d.result)}`
                            )?.join('\n') || null,
                            disabled: true
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldTextArea({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}requesterRemark`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 5 }, wrapperCol: { xs: 24, md: 19 } }),
                label: () => i18n.global.t("model.feeStatement.requesterRemark"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.requesterRemark,
                            "onUpdate:value": value => (model.requesterRemark = value),
                            disabled: viewOnly
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldTextArea({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}officerRemark`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 5 }, wrapperCol: { xs: 24, md: 19 } }),
                label: () => i18n.global.t("model.feeStatement.officerRemark"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.officerRemark,
                            "onUpdate:value": value => (model.officerRemark = value),
                            disabled: viewOnly
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            })
        ]
    });
};

export const createFieldInvoiceInfo = ({ props, data, key }) => {
    const { viewOnly, menuContext } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    const prefix = key ? `${key}.` : "";
    return putField({
        data,
        fields: [
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refRequest.refRequestDoc.value`,
                colProp: () => ({ xs: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.request.refRequestDoc"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refRequest?.refRequestDoc?.value,
                            disabled: true,
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) }
            }),
            {
                visible: () => !model.receiptCode,
                colProp: () => ({ xs: 24 }),
            },
            createFieldInput({
                visible: ({ field }) => model.receiptCode && conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}receiptCode`,
                colProp: () => ({ xs: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.feeStatement.receiptCode"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.receiptCode,
                            disabled: true,
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) }
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refRequest.requestCode`,
                colProp: () => ({ xs: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.feeStatement.refRequest"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refRequest?.requestCode,
                            disabled: true,
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) }
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}feeCode`,
                colProp: () => ({ xs: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.feeStatement.feeCode"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.feeCode,
                            disabled: true,
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) }
            }),
            createFieldDate({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}lastStatus.waitReceive.0.statusDatetime`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("views.request.requestor.requestDate"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.lastStatus?.waitReceive?.[0]?.statusDatetime ? moment(model.lastStatus?.waitReceive?.[0]?.statusDatetime)?.format("YYYY-MM-DD") : null,
                            disabled: true
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldDate({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}feeDate`,
                colProp: () => ({ xs: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.feeStatement.feeDate"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.feeDate,
                            disabled: true,
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) }
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refRequest.refHaz.refUserCompany.companyNameTh`,
                colProp: () => ({ xs: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.feeStatement.companyName"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.companyName,
                            disabled: true,
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) }
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refRequest.refHaz.refUserCompany.requestNumber1`,
                colProp: () => ({ xs: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.feeStatement.requestNumber1"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.requestNumber1,
                            disabled: true,
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) }
            }),
            {
                visible: () => true,
                colProp: () => ({ xs: 12 })
            },
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refRequest.refHaz.refUserCompany.requestNumber2`,
                colProp: () => ({ xs: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.feeStatement.requestNumber2"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.requestNumber2,
                            disabled: true,
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) }
            }),
            {
                visible: () => true,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24 }, wrapperCol: { xs: 24 } }),
                inputRender: () => {
                    const componentProp = lodash.merge(
                        {
                            menuContext: menuContext,
                            viewOnly: viewOnly,
                            dataProp: data,
                            canCreate: !viewOnly,
                            canDelete: !viewOnly
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { componentKey: "FeeStatementInlineList" } })
                    );
                    return <FeeStatementInlineList {...componentProp}></FeeStatementInlineList>;
                }
            }
        ]
    });
};
